import { type JSX, Show } from 'solid-js';

// The card chrome every widget renders inside (arc 101 slice 09, task #81): a
// spec §3.3 `.card` with an optional title header + a content slot. Kept separate
// from the kind presenters so each of those stays a pure content renderer (one
// reason to change). `kind` tags the card for per-kind styling hooks. Titles are
// h2 — widgets sit directly under the board's h1.
export function WidgetFrame(props: {
  title?: string | undefined;
  kind: string;
  children: JSX.Element;
}): JSX.Element {
  return (
    <section class={`card widget widget--${props.kind}`}>
      <Show when={props.title}>
        <div class="card__header">
          <h2 class="card__title">{props.title}</h2>
        </div>
      </Show>
      <div class="card__content">{props.children}</div>
    </section>
  );
}
